export function Footer() {
    return (
        <footer className="app-footer">
            <div className="app-footer__left">
                2026 Copyright &copy; 2009 - 2026 Arizona Department of Health Services. All rights reserved.
            </div>
            <div className="app-footer__right">
                <a href="https://data.azdhs.gov/policies-and-terms-of-use/privacy-policy" target="_blank">Privacy Policy</a>
                <a href="https://data.azdhs.gov/need-help/contact-us" target="_blank">Contact</a>
            </div>
        </footer>
    );
}